export default {
    isInAlertList: state => itemId => {
        return state.notifList.some((item) => item === itemId)
    },

    isInitiate: state => () => {
        return state.initiateAwal
    }
}
